import React from 'react';
import SEO from '../components/SEO';
import '../styles.css';

function SecurityPage() {
  return (
    <div className="page-container">
      <SEO
        title="Virgil Security"
        description="An overview of Virgil authentication, payment, data-transfer, download, and vulnerability-reporting controls."
        url="https://www.virgil.com.ai/security"
      />
      <section className="content-section">
        <h1 className="page-title">Security</h1>
        <div className="page-content">
          <p className="page-lead">
            We take your data and privacy seriously. Here's how.
          </p>
          
          <h2>Data Encryption</h2>
          <p>
            Virgil uses TLS for data sent between supported clients and our services.
          </p>
          
          <h2>Secure Authentication</h2>
          <p>
            We use Auth0 for account access. Multi-factor authentication is supported, and we don't store passwords directly.
          </p>
          
          <h2>Payment Security</h2>
          <p>
            Payment processing is handled by Stripe (PCI-compliant). We never see or store your full credit card number.
          </p>
          
          <h2>Data Storage</h2>
          <p>
            Service data is protected with provider access controls and restricted credentials. Backup and restoration procedures are part of the launch-readiness checklist.
          </p>
          
          <h2>AI Model Security</h2>
          <p>
            When you use AI features, relevant content is transmitted over encrypted connections to the provider you select, such as OpenAI, Anthropic, Google, xAI, or an open-model provider.
          </p>
          
          <h2>Vulnerability Reporting</h2>
          <p>
            If you discover a security vulnerability, please report it to <a href="mailto:support@virgil.com.ai">support@virgil.com.ai</a>. We appreciate responsible disclosure and will respond promptly.
          </p>
          
          <h2>Compliance</h2>
          <p>
            Privacy rights vary by location. See the Privacy Policy or contact support to request access, correction, export, or deletion.
          </p>
        </div>
      </section>
    </div>
  );
}

export default SecurityPage;

